import Component from '../core/Component'

export default class PopupOpener extends Component {
    constructor($element) {
        super($element)
        this.$input = this.$element.find('input')
    }

    prepare() {
        var self = this

        this.$element.append('<div class="range__stars"></div>')
        this.$holder = this.$element.find('.range__stars')
        for(var i = 0; i < 5; i++) {
            this.$holder.append('<div class="range__star"></div>')
        }

        this.$stars = this.$element.find('.range__star')

        this.$stars.on('click', event => {
            var n = $(event.currentTarget).index()

            this.$input.val(n + 1)

            this.$stars.removeClass('is-checked')
            this.$stars.each((index, item) => {
                if (index <= n) {
                    $(item).addClass('is-checked')
                }
            })
        })

        var value = this.$input.val()
        this.$stars.each((index, item) => {
            if (index < value) {
                $(item).addClass('is-checked')
            }
        })
    }

}


// WEBPACK FOOTER //
// ./components/Range.js